import { PACKAGE_NAMES } from '@main/services/limit-upgrade/limit-upgrade.types';

import { SemrushUpgradeOffer } from './semrush.types';

export function isSemrushUpgradeOffer(value: unknown): value is SemrushUpgradeOffer {
    if (!value || typeof value !== 'object') {
        return false;
    }

    const offer = value as Partial<SemrushUpgradeOffer>;

    return isPackageName(offer.upgradeFrom) && isPackageName(offer.upgradeTo);
}

function isPackageName(value: unknown): value is PACKAGE_NAMES {
    return Object.values(PACKAGE_NAMES).includes(value as PACKAGE_NAMES);
}
